import { entity } from '../region.json';
import {
  SUPPORTED_LANGS,
  LANGS_TO_ENTITIES,
} from '../src/shared/entityHelpers';

const check = lang => SUPPORTED_LANGS.includes(lang);
// If a user enters the website and their main language is supported
// by one of our websites - example, Swedish user enters the German website,
// then we show a popup asking if they would like to go to the Swedish website.
// This function checks the user's languages and sees if we support their language.
export default function shouldShowPopup() {
  const [language] = window.navigator.languages.filter(check);
  return (
    language in LANGS_TO_ENTITIES && LANGS_TO_ENTITIES[language] !== entity
  );
}
